var map = {
	"./assessment_center.png": 99639,
	"./digital-codes-ICC-phones-1.webp": 15891,
	"./digital-codes-ICC-phones-2.webp": 50326,
	"./pc_laptop.webp": 19738,
	"./pc_laptop_mob_1.webp": 87676,
	"./ready-for-certificate.webp": 47162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25245;